<template>
  <div class="relative theme-input-wrapper">
    <div class="selected-color-indicator"></div>
    <form-input
      v-bind="safeAttrs"
      v-model="value"
      item-component="Select2ThemeItem"
      :label="false"
      type="select2"
      :translate-list="true"
      :list="internalThemeList"
      :wrapper-margins="false"
      :auto-input-styleing="false">
    </form-input>
  </div>
</template>

<script>
import ThemeInputMixin from "@/client/extensions/mixins/baseComponents/form/controls/input/themeInput.js";
import SimpleInputMixin from "@/client/extensions/mixins/baseComponents/form/controls/input/simpleInput.js";
import FormInputMixin from '@/client/extensions/mixins/baseComponents/form/controls/formInput'

export default {
  mixins: [SimpleInputMixin, ThemeInputMixin, FormInputMixin],

  props: {
    translateList: {
      type: Boolean,
    },
  },
  data() {
    return {
      list: [
        { value: "bg", label: "bg" },
        { value: "lead", label: "lead" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.theme-input-wrapper :deep(.field__element) {
  padding-inline-start: 4em !important;
}
.selected-color-indicator {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  margin-inline-start: 2em;
  height: 1.7em;
  width: 1.7em;
  border: 1px solid var(--c-gray-2);
  background: v-bind(computedThemeCssValue);
  z-index: 2;
  transition: background-color 150ms ease;
}
</style>
